import { RootState } from 'shared/config/store'

export const getDraggedItems = (state: RootState) => state.drag.draggedItems
export const getIsDragging = (state: RootState) => state.drag.isDragging
export const getIsItemDragged = (itemId: string) => (state: RootState) =>
    state.drag.draggedItems.includes(itemId) 